import { Box, Checkbox, Divider, Stack, Text } from "@mantine/core";
import React from "react";
import { IRapportOptionSection } from "./types";

const ReportOptionSection: React.FC<{
  optionSection: IRapportOptionSection;
  sectionKey: string;
  setOption: (sectionKey: string, option: string) => void;
}> = ({ optionSection, sectionKey, setOption }) => {
  return (
    <Box w="50%">
      <Divider
        my="sm"
        label={
          <Text fz="lg" fw={600}>
            {optionSection.title}
          </Text>
        }
        labelPosition="left"
        mb="md"
      />
      {optionSection.instructions && (
        <Text fw={500} size="md" mb="md">
          {optionSection.instructions}
        </Text>
      )}
      <Stack gap="xs">
        {Object.keys(optionSection.options).map((option) => {
          const opt = optionSection.options[option];
          return (
            <Checkbox
              key={option}
              label={opt.name}
              checked={opt.isSelected}
              onChange={() => setOption(sectionKey, option)}
              size="sm"
              fw={400}
            />
          );
        })}
      </Stack>
    </Box>
  );
};

export default ReportOptionSection;
